<div class="fullscreen-container">

  <div class="fullscreen-header">
    <span class="title">
      {{selectedMeasure | titlecase}} Chart
    </span>
  </div>

  <app-chart
    [selectedDeviceIDs]="selectedDeviceIDs"
    [selectedMeasure]="selectedMeasure"
    [selectedDuration]="selectedDuration"
    [iaqDevices]="iaqDevices"
    [formattedStartDate]="formattedStartDate"
    [formattedEndDate]="formattedEndDate"
    [showExpandButton]="false">
  </app-chart>

</div>